module.exports = __webpack_public_path__ + "static/media/active-left-shield.5d3c1303.svg";